import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { mdiFilterPlusOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { Button, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { FilterChipsSummary } from './FilterChipsSummary';
import { FilterFormDialog } from './FilterFormDialog/FilterFormDialog';
import { isEmptyFilter } from './helpers';
export function Filters({ conditions, onConditionsChange, filterColumns, enableAutocomplete, }) {
    const [addFilterDialogOpen, setAddFilterDialogOpen] = useState(false);
    const onSubmit = (data) => {
        if (data.andConditions.length === 0) {
            onConditionsChange(null);
        }
        else {
            onConditionsChange((prev) => ({ ...(prev ?? {}), ...data }));
        }
    };
    const handleRemoveCondition = (andIndex, orIndex) => {
        const andConditions = [...(conditions?.andConditions ?? [])];
        const group = andConditions[andIndex];
        if (!group?.orConditions)
            return;
        const orConditions = [...group.orConditions];
        orConditions.splice(orIndex, 1);
        if (orConditions.length === 0) {
            andConditions.splice(andIndex, 1);
        }
        else {
            andConditions[andIndex] = { ...group, orConditions };
        }
        if (andConditions.length === 0) {
            onConditionsChange(null);
        }
        else {
            onConditionsChange((prev) => ({ ...(prev ?? {}), andConditions }));
        }
    };
    const hasFilters = useMemo(() => !isEmptyFilter(conditions ?? null), [conditions]);
    return (_jsxs(_Fragment, { children: [hasFilters && (_jsxs(_Fragment, { children: [_jsxs(Typography, { component: "span", sx: {
                            fontSize: 12,
                            color: 'text.secondary',
                            fontWeight: 500,
                            mb: 0.5,
                        }, children: [_jsx(FormattedMessage, { id: "filter.currentFilters.label", defaultMessage: "Filtered by" }), ":"] }), _jsx(FilterChipsSummary, { conditions: conditions, filterColumns: filterColumns, onRemoveCondition: handleRemoveCondition })] })), _jsx(Button, { size: "small", variant: "text", color: "primary", startIcon: _jsx(Icon, { path: mdiFilterPlusOutline, size: 0.8 }), onClick: () => setAddFilterDialogOpen(true), children: hasFilters ? (_jsx(FormattedMessage, { id: "tableFiltering.editFilters.button", defaultMessage: "Edit filters" })) : (_jsx(FormattedMessage, { id: "tableFiltering.addFilter.button", defaultMessage: "Add filter" })) }, "edit"), _jsx(FilterFormDialog, { open: addFilterDialogOpen, onClose: () => setAddFilterDialogOpen(false), onApply: (data) => {
                    onSubmit(data);
                    setAddFilterDialogOpen(false);
                }, filterColumns: filterColumns, enableAutocomplete: enableAutocomplete, initialValues: conditions })] }));
}
//# sourceMappingURL=Filters.js.map